import angular from 'angular';
import translate from 'angular-translate';
import cacheService from './cache.service';
import config from '../config/config';

class LanguageService {

    constructor(cacheService, $translate, CONFIG) {
        'ngInject';

        this.cacheService = cacheService;
        this.$translate = $translate;
        this.CONFIG = CONFIG;

        //TODO use WeakMap
        this._wm = {};
        this.populateTranslationKeys();
    }

    populateTranslationKeys() {
        this._wm.languagesByUrl = {};
        for (var key in this.CONFIG.languages) {
            this._wm.languagesByUrl[this.CONFIG.languages[key].key] = angular.copy(this.CONFIG.languages[key]);
            this._wm.languagesByUrl[this.CONFIG.languages[key].key].translationKey = key;
        }
    }

    findLanguageByKey(key) {
        var language = this._wm.languagesByUrl[key] || null;

        if (language) {
            return language;
        }

        throw new Error("Language not found");
    }

    getDefaultLanguage() {
        return this.CONFIG.languages[this.CONFIG.default_locale];
    }

    getLanguageByKey(key) {
        try {
            return this.findLanguageByKey(key);
        }
        catch (e) {
            return this.getDefaultLanguage();
        }
    }

    setLanguage(lang) {
        this.currentLanguage = this.getLanguageByKey(lang);
        this.$translate.use(this.currentLanguage.translationKey);
    }
}

const module = angular.module('st.services.language', [
    cacheService,
    translate,
    config
])
    .service('languageService', LanguageService)
    .name;

export default module;



// WEBPACK FOOTER //
// ./client/app/services/language.service.js